/**
 * Stato locale del selettore «Vedi come» (impersonazione per verifica).
 *
 * Persistito in localStorage così sopravvive ai reload. Riservato a
 * MAITIME_STAFF: il backend onora l'header `X-Vedi-Come` solo se il chiamante
 * reale è staff, ed è in sola lettura (le scritture rispondono 403).
 *
 * Il valore dell'header è:
 *   - `ruolo:<slug>` per impersonare un RUOLO (anche senza utente reale)
 *   - `<email>`      per impersonare un UTENTE reale (applica i suoi override)
 */

const STORAGE_KEY = "mp_vedi_come";

/** Evento window emesso a ogni set/clear, per re-render reattivo (banner+selettore). */
export const VEDI_COME_EVENT = "vedi-come:change";

function notifyChange(): void {
  window.dispatchEvent(new Event(VEDI_COME_EVENT));
}

export type VediComeStato = {
  tipo: "ruolo" | "utente";
  /** Slug del ruolo (es. `mp_logistica`) o email dell'utente. */
  valore: string;
  /** Etichetta leggibile mostrata nel banner. */
  label: string;
};

export function getVediCome(): VediComeStato | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as VediComeStato;
    if (!parsed?.tipo || !parsed?.valore) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setVediCome(stato: VediComeStato): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(stato));
  notifyChange();
}

export function clearVediCome(): void {
  localStorage.removeItem(STORAGE_KEY);
  notifyChange();
}

/** Valore dell'header `X-Vedi-Come`, o `null` se l'impersonazione è inattiva. */
export function getVediComeHeader(): string | null {
  const s = getVediCome();
  if (!s) return null;
  return s.tipo === "ruolo" ? `ruolo:${s.valore}` : s.valore;
}
